import React, { useEffect, useMemo } from "react";
import {
  useTable,
  useRowSelect,
  useExpanded,
  useGlobalFilter,
} from "react-table";
import { GlobalFilter } from "./GlobalSearch";

const CustomTable = ({
  data,
  columns,
  showCheckboxes = false,
  onCheckboxSelect,
  centerAlignedColumns = [],
  globalSearchPosition = {
    top: "-63px",
    left: "211px",
  },
  isGlobalSearchEnable = false,
}) => {
  const propData = useMemo(() => data, [data]);
  const propColumn = useMemo(() => columns, [columns]);

  const tablePlugins = useMemo(() => {
    const base = [useGlobalFilter, useExpanded];
    if (!showCheckboxes) {
      return base;
    }
    return [
      ...base,
      useRowSelect,
      (hooks) => {
        hooks.visibleColumns.push((columns) => [
          {
            id: "selection",
            Header: ({ getToggleAllRowsSelectedProps }) => {
              const { indeterminate, ...rest } = getToggleAllRowsSelectedProps();
              return (
                <input
                  type="checkbox"
                  {...rest}
                  ref={(el) => {
                    if (el) el.indeterminate = indeterminate;
                  }}
                  style={{ cursor: "pointer" }}
                />
              );
            },
            Cell: ({ row }) => {
              const { indeterminate, ...rest } = row.getToggleRowSelectedProps();
              return (
                <input
                  type="checkbox"
                  {...rest}
                  ref={(el) => {
                    if (el) el.indeterminate = indeterminate;
                  }}
                  style={{ cursor: "pointer" }}
                />
              );
            },
          },
          ...columns,
        ]);
      },
    ];
  }, [showCheckboxes]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    setGlobalFilter,
    state,
  } = useTable(
    {
      columns: propColumn,
      data: propData,
    },
    ...tablePlugins
  );

  useEffect(() => {
    if (onCheckboxSelect) {
      onCheckboxSelect(selectedFlatRows);
    }
  }, [selectedFlatRows]);

  const { globalFilter } = state;
  return (
    <div className="relative overflow-y-scroll" style={{ maxHeight: "340px" }}>
      {isGlobalSearchEnable && (
        <div className="absolute" style={globalSearchPosition}>
          <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
        </div>
      )}
      <table
        {...getTableProps()}
        className="custom-table font-size-small font-family-medium"
        // style={{ height: '800px' }}
      >
        <thead className="sticky" style={{ top: "0px" }}>
          {headerGroups?.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  className={`table-header ${
                    centerAlignedColumns.includes(column.id)
                      ? "center-aligned"
                      : ""
                  }`}
                >
                  <div className="w-max mr-4">{column.render("Header")}</div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()} className="bg-[var(--whiteColor)]">
          {data?.length === 0 ? (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to show
              </td>
            </tr>
          ) : (
            rows?.map((row) => {
              prepareRow(row);
              return (
                <tr
                  {...row.getRowProps()}
                  className={row.id.includes(".") ? "bg-[#EAEAEA]" : ""}
                >
                  {row.cells.map((cell) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        className={`table-cell ${
                          centerAlignedColumns.includes(cell.column.id)
                            ? "center-aligned"
                            : ""
                        }`}
                        style={{ pointerEvents: "auto" }}
                      >
                        <div
                          className="w-max mr-4"
                          style={{
                            maxWidth: "200px",
                            overflow: "visible",
                            pointerEvents: "auto",
                          }}
                        >
                          {cell.render("Cell")}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CustomTable;
